import React, { useMemo } from "react";
import { Button, Link, spacing, colors, styles } from "../library";
import { css } from "glamor";
import { HiOutlineDownload } from "react-icons/hi";
import { PiVideo } from "react-icons/pi";
import { getFileExtensionStyle } from "../../utils/fileExtensionHelpers";

const downloadLinkStyle = css(styles.transition, {
  borderRadius: "10px",
  padding: spacing.s,
  display: "flex",
  gap: spacing.s,
  alignItems: "center",
  width: "100%",
  backgroundColor: colors.greyClear,
  color: `${colors.greyShadow} !important`,
  border: `1px solid ${colors.greyClear}`,
  lineHeight: 1.5,
  "& + &": {
    marginTop: spacing.s,
  },
});

const badgeStyle = {
  backgroundColor: colors.greyLight,
  color: colors.greyShadow,
  padding: "2px 4px",
  borderRadius: "5px",
  fontSize: "12px",
  fontWeight: "700",
  lineHeight: 1
};

const textStyle = {
  flex: 1
}

const FileExtensiongBadge = ({ extension = "arquivo" }) => {
  const style = useMemo(() => getFileExtensionStyle(extension, badgeStyle), [extension]);

  return <div style={style}>{extension.toUpperCase()}</div>
}

export default function DownloadsItem({ file, lesson, index }) {
  const fileTitle = file.name || `Arquivo ${index + 1}`
  const fileExtension = file.url?.split(".")?.at(-1);

  return (
    <div className={downloadLinkStyle}>
      <FileExtensiongBadge extension={fileExtension} />

      <p style={textStyle}>{lesson ? lesson.name : fileTitle}</p>

      {lesson && (
        <Link to={`/courses/${file.courseId}/lessons/${lesson.id}`}>
          <Button icon={<PiVideo size={20} />} color="download" popupText="Visualizar Aula" />
        </Link>
      )}

      <Link href={file.url} target="_blank">
        <Button icon={<HiOutlineDownload size={20} />} color="download" popupText="Download" />
      </Link>
    </div>
  );
}
